import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ce0b60a4")
const _hoisted_1 = { class: "asset-holder" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Asset = _resolveComponent("Asset")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Asset, {
      asset: _ctx.asset,
      "thumb-size": "320x320"
    }, null, 8, ["asset"])
  ]))
}